import React from "react";
import { Order } from "src/shared/services/interfacev2";
import { useUser } from "src/shared/context/UserContext";

interface Props {
  selectedOrder: Order;
  getBgClass: () => string;
  isCancelled: boolean;
  isCompleted: boolean;
}

const OrderHeader: React.FC<Props> = ({ selectedOrder, getBgClass, isCancelled, isCompleted }) => {
  const { userConfigration } = useUser();
  const toBoolean = (value: any) => value === true || value === "true";
  const tipsEnabled = toBoolean(userConfigration?.tipsEnabled);
  const txn = selectedOrder.orders?.[0];
  const totalAmount = Number(txn?.finalAmount ?? 0) + (tipsEnabled ? Number(txn?.tip ?? 0) : 0);

  return (
    <div className={`${getBgClass()} rounded-t-xl px-4 py-[2px] flex-shrink-0`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center justify-between gap-2">
          <h1 className="text-xl font-bold text-white">Order Details</h1>
          {/* <div className="flex items-center gap-2">
            <span className={`px-2 py-1 rounded-full text-xs font-bold ${isCancelled ? "bg-red-500 text-white" : isCompleted ? "bg-green-500 text-white" : "bg-amber-500 text-white"}`}>
              {isCancelled ? "Cancelled" : isCompleted ? "Completed" : "Active"}
            </span>
          </div> */}
        </div>

        <div className="text-right mr-5">
          <p className="text-blue-100 text-xs">Total Amount</p>
          <p className="text-xl font-bold text-white">{totalAmount}</p>
        </div>
      </div>
    </div>
  );
};

export default OrderHeader;
